import { render, staticRenderFns } from "./EditVenueLabel.vue?vue&type=template&id=5ea75efb"
import script from "./EditVenueLabel.vue?vue&type=script&lang=ts"
export * from "./EditVenueLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports